import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { videoApi } from "../../../../config/videoApi";
import { util } from "../../../../config/util";
import LectureListSection from "./LectureListSection";
import { lectureModels } from "../../../main/components/RecommendLeture";

const cardStyle: React.CSSProperties = {
  backgroundColor: "#243044",
  border: "1px solid rgba(255,255,255,0.12)",
  color: "#e2e8f0",
};

const cardBodyStyle: React.CSSProperties = {
  backgroundColor: "#243044",
  color: "#e2e8f0",
};

const Section = () => {
  const [cardItems, setCardItems] = useState([]);
  const history = useHistory();

  useEffect(() => {
    (async () => {
      try {
        const cardRes = await videoApi.getMainCardCourseAsync();
        setCardItems(cardRes.data.courses);
      } catch (e) {
        console.error("BEST 강의 로드 실패:", e);
      }
    })();
  }, []);

  return (
    <main id="wrap" className="bg-dark">
      <article>
        <section className="page-top-banner-two">
          <div className="container">
            <div className="text-box">
              <div>쉽고 재미있게 공부하자!</div>
              <h2 className="text-white">나의 가치를 성장시키는 강의</h2>
            </div>
          </div>
        </section>
        <section>
          <div className="container page">
            <div className="section-header text-white">BEST 강의</div>
            <div
              className="card-wrap column3 aos-init aos-animate"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              {cardItems.map((card: any) => {
                const starCount = Math.floor(card.review_avg || 0);
                const userCount = lectureModels.find(
                  (m) => m.id === card.id
                )?.userCount;
                return (
                  <div
                    className="card pointer"
                    key={card.id}
                    style={cardStyle}
                    onClick={() =>
                      history.push(`video/curriculum/${card.id}`)
                    }
                  >
                    <img
                      src={card.card_image}
                      className="card-img-top"
                      alt={card.title}
                      style={{ aspectRatio: "16/9", objectFit: "cover" }}
                    />
                    <div className="card-body" style={cardBodyStyle}>
                      <h5 className="card-title" style={{ color: "#fff" }}>
                        {card.title}
                      </h5>
                      <div className="body2 mb-2" style={{ color: "#94a3b8" }}>
                        {card.description}
                      </div>
                      <div className="card-text mb-2">
                        <div className="card-caption">
                          {card.review_avg != null && (
                            <div className="rating">
                              <span>
                                {Number(card.review_avg).toFixed(1)}
                              </span>
                              <div className="star-wrap">
                                {Array.from({ length: starCount }).map(
                                  (_, i) => (
                                    <span key={i}></span>
                                  )
                                )}
                              </div>
                            </div>
                          )}
                          <div className="price" style={{ color: "#fff", fontWeight: 700 }}>
                            <span className="discount" style={{ color: "#8b9ab8" }}>
                              <span>
                                {util.addComma(card.origin_amount)}
                              </span>
                              원
                            </span>
                            <span>{util.addComma(card.amount)}</span>원
                          </div>
                        </div>
                      </div>
                      <div className="badge-wrap">
                        {userCount != null && (
                          <span
                            className="badge rounded-pill"
                            style={{
                              backgroundColor: "rgba(99,102,241,0.15)",
                              color: "#a5b4fc",
                            }}
                          >
                            {userCount}명
                          </span>
                        )}
                        <span
                          className="badge rounded-pill"
                          style={{
                            backgroundColor: "rgba(99,102,241,0.25)",
                            color: "#c7d2fe",
                          }}
                        >
                          {card.category}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
        <LectureListSection />
      </article>
    </main>
  );
};

export default Section;
